import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
	
	$stateProvider.states(['company.sharing-center.shared-passwords.manage.share', 'company.sharing-center.shared-authenticators.manage.share','company.sharing-center.shared-notes.manage.share'], {
		url: '/share', 
		params: { sharedAccount: {} },
		component: 'companySharingCenterShare',
		resolve: {users}
	});
}

/** @ngInject */
function users(SharedAccountsService,  $stateParams,isNote) {
	if(isNote){
		return SharedAccountsService.getAllCompanyNotesUsers({
                companyId: $stateParams.companyId,
                id: $stateParams.sharedAccountId,
            }, {}).$promise.then((sharedUsersList) => {
                return sharedUsersList;
            });
	}
	return SharedAccountsService.getSaaspassUsersByCorporateServiceAccountId({
		companyId: $stateParams.companyId,
		id: $stateParams.sharedAccountId,
	}, {}).$promise.then(({ sharedUsersList }) => {
		return sharedUsersList;
	});
}






// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/share/share.state.js